import { Action, createReducer, on } from '@ngrx/store'

import { ApplicationSettingsState } from '../models'
import { ApplicationSettingsActions } from './application-settings.actions'

export const initialState: ApplicationSettingsState = {
  rateCardMetaStructure: null,
  rateCardMetaStructureLoading: false,
  settings: [],
  settingsLoading: false,
  settingsLoadingMap: {},
}

const rateCardMetaStructureLoadingHandler = (isLoading: boolean) => (state: ApplicationSettingsState) => ({
  ...state,
  rateCardMetaStructureLoading: isLoading,
})

const getRateCardMetaStructureSuccessHandler = (state: ApplicationSettingsState, { rateCardMetaStructure }) => ({
  ...state,
  rateCardMetaStructure,
  rateCardMetaStructureLoading: false,
})

const applicationSettingsLoadingHandler = (isLoading: boolean) => (state: ApplicationSettingsState) => ({
  ...state,
  settingsLoading: isLoading,
})

const setApplicationSettingsHandler = (state: ApplicationSettingsState, { settings }) => ({ ...state, settings })

const updateApplicationSettingLoadingHandler =
  (isLoading: boolean) =>
  (state: ApplicationSettingsState, { setting }) => ({
    ...state,
    settingsLoadingMap: { ...state.settingsLoadingMap, [setting.id]: isLoading },
  })

export const ApplicationSettingsReducer = createReducer(
  initialState,
  on(ApplicationSettingsActions.getRateCardMetaStructure, rateCardMetaStructureLoadingHandler(true)),
  on(ApplicationSettingsActions.getRateCardMetaStructureFail, rateCardMetaStructureLoadingHandler(false)),
  on(
    ApplicationSettingsActions.getRateCardMetaStructureSuccess,
    ApplicationSettingsActions.saveRateCardMetaStructureSuccess,
    getRateCardMetaStructureSuccessHandler
  ),
  on(ApplicationSettingsActions.getApplicationSettings, applicationSettingsLoadingHandler(true)),
  on(
    ApplicationSettingsActions.getApplicationSettingsFail,
    ApplicationSettingsActions.getApplicationSettingsSuccess,
    applicationSettingsLoadingHandler(false)
  ),
  on(
    ApplicationSettingsActions.getApplicationSettingsSuccess,
    ApplicationSettingsActions.setApplicationSettings,
    setApplicationSettingsHandler
  ),
  on(ApplicationSettingsActions.updateApplicationSetting, updateApplicationSettingLoadingHandler(true)),
  on(
    ApplicationSettingsActions.updateApplicationSettingFail,
    ApplicationSettingsActions.updateApplicationSettingSuccess,
    updateApplicationSettingLoadingHandler(false)
  )
)

export function applicationSettingsReducer(
  state: ApplicationSettingsState | undefined,
  action: Action
): ApplicationSettingsState {
  return ApplicationSettingsReducer(state, action)
}
